import React from 'react'
import { Link } from 'react-router-dom';
import BreadCrum from '../components/BreadCrum'
import Container from '../components/Container';
import Meta from '../components/Meta'

const Signup = () => {
  return (
    <>
        <Meta title='Sign Up'/>
        <BreadCrum title='Sign Up' />
        <Container class1="login-wrapper py-2 home-wrapper-2">
            <div className="row">
                <div className="col-12">
                    <div className="auth-card">
                        <h3 className='text-center mb-3'>Sign Up</h3>
                        <form action="" className='d-flex flex-column gap-15'>
                            <div>
                                <input type="text" name='name' placeholder='Full Name' className="form-control" />
                            </div>
                            <div  className='mt-1'>
                                <input type="email" name='email' placeholder='Email Address' className="form-control" />
                            </div>
                            <div  className='mt-1'>
                                <input type="tel" name='mobile' placeholder='Mobile Number' className="form-control" />
                            </div>
                            <div className='mt-1'>
                                <input type="password" name='password' placeholder='Password' className="form-control" />
                            </div>
                            <div className='mt-1'>
                                <input type="password" name='password_confirmation' placeholder='Confirm Password' className="form-control" />
                            </div>
                            <div>
                                <div className="mt-3 d-flex justify-content-center gap-15 align-items-center">
                                    <button type='submit' className="button border-0">Create Account</button>
                                    <p>Already have account? <Link to='/login'>Login</Link></p>
                                
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Container>
    </>
  )
}

export default Signup